import {
  FileCell,
} from './FileCell';

export default FileCell;
